import { render, staticRenderFns } from "./StrapiPageView.vue?vue&type=template&id=3a46d37e"
import script from "./StrapiPageView.vue?vue&type=script&lang=js"
export * from "./StrapiPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports